import cookie from "cookie-monster";
import JSON5 from "json5";

export function clearCookies() {
  cookie.clear();
}

export default function getCookie(key) {
  const retVal = cookie.getItem(key);

  // console.debug('cookie key: ' + key);
  // console.debug('cookie: ' + retVal);
  try {
    if (retVal) {
      // console.debug('cookie.replace...: ' + retVal.replace(/\"/g, ""));
      try {
        // console.debug('JSON5.parse...: ');
        // console.debug(JSON5.parse(retVal.replace(/\"/g, "")));
        return JSON5.parse(retVal.replace(/\"/g, ""));
      } catch (e) {}
      return JSON5.parse(retVal);
    } else {
      return retVal;
    }
  } catch (e) {
    console.error("getCookie error: ");
    console.error("cookie value: " + retVal);
    console.error(e);
    return retVal;
  }
}
